import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type UiIconActionIcon = 'edit' | 'delete' | 'view' | 'download';

/**
 * Átomo: botón ghost 1.75rem con ícono de fila (Editar / Eliminar).
 * No sustituye a `ui-button variant="icon"` (círculo con fondo).
 */
@Component({
  selector: 'ui-icon-action',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './icon-action.component.html',
  styleUrl: './icon-action.component.scss',
  host: { class: 'ui-icon-action-host' },
})
export class UiIconActionComponent {
  readonly icon = input.required<UiIconActionIcon>();
  readonly ariaLabel = input.required<string>();
  readonly disabled = input(false);
  readonly type = input<'button' | 'submit'>('button');

  readonly pressed = output<void>();
}
